import { client } from '../apollo';
import { PAYMENT_OPTION_NAMES } from '../../constants/payments';
import { getAnalyticsContext } from '../analyticsContext';
import { PAYMENT_METHODS } from '../../queries/payments/paymentMethods';
import { ATTACH_PAYMENT_METHOD } from '../../mutations/payments/attachPaymentMethod';
import { DELETE_PAYMENT_METHOD } from '../../mutations/payments/deletePaymentMethod';
import { CHECKOUT_PAYMENT } from '../../mutations/payments/checkoutPayment';

const toLegacyPaymentMethod = (paymentMethod) => ({
  ...paymentMethod,
  card: paymentMethod?.card
    ? {
        ...paymentMethod.card,
        exp_month: paymentMethod.card.expiryMonth,
        exp_year: paymentMethod.card.expiryYear,
      }
    : null,
});

const toCheckoutPaymentType = (paymentOption) =>
  paymentOption === PAYMENT_OPTION_NAMES.PAY_MONTHLY ? 'PLAN' : 'SINGLE';

export const listPaymentMethods = async () => {
  const { data } = await client.query({
    query: PAYMENT_METHODS,
    fetchPolicy: 'network-only',
  });

  return (data?.paymentMethods || []).map(toLegacyPaymentMethod);
};

export const attachPaymentMethod = async (paymentMethodId) => {
  await client.mutate({
    mutation: ATTACH_PAYMENT_METHOD,
    variables: {
      paymentMethodId,
    },
  });
};

export const deletePaymentMethod = async (paymentMethodId) => {
  await client.mutate({
    mutation: DELETE_PAYMENT_METHOD,
    variables: {
      paymentMethodId,
    },
  });
};

export const checkoutPayment = async (paymentData, paymentOption) => {
  const { data } = await client.mutate({
    mutation: CHECKOUT_PAYMENT,
    variables: {
      input: {
        amount: paymentData.amount,
        quoteId: paymentData.bookingId,
        protectionType: paymentData.protectionType,
        analyticsContext: getAnalyticsContext(),
        paymentType: toCheckoutPaymentType(paymentOption),
        ...(paymentData.paymentIntentId
          ? {
              paymentIntentId: paymentData.paymentIntentId,
            }
          : {}),
        ...(paymentData.paymentMethodId
          ? {
              paymentMethodId: paymentData.paymentMethodId,
            }
          : {}),
      },
    },
  });

  const checkoutResponse = data?.checkoutPayment;

  return {
    ...checkoutResponse,
    bookingProtection: checkoutResponse?.paymentInformation?.bookingProtection,
    requiresAction:
      !checkoutResponse?.paymentComplete &&
      Boolean(checkoutResponse?.paymentIntentClientSecret),
  };
};
